import React, { useState } from 'react';
import './LeadershipEtStrategieDetails.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const trainings = [
  {
    id: 'strategic-management',
    title: 'Management Stratégique de l’Entreprise',
    details: [
      { detail: 'Description', description: 'Le management stratégique permet à l’entreprise de créer des avantages compétitifs durables.' },
      {
        detail: 'Objectives',
        description: (
          <ul>
            <li>Connaitre les enjeux et maitriser les principes de la réflexion stratégique</li>
            <li>Comprendre la démarche et les composantes du management stratégique de l’entreprise</li>
            <li>Être en mesure de formuler et de mettre en œuvre des recommandations stratégiques à même de créer des avantages compétitifs durables.</li>
          </ul>
        ),
      },
    ],
  },
];

const LeadershipEtStrategieDetails = () => {
  const [selectedTraining, setSelectedTraining] = useState(null);

  // Function to show the selected training details
  const handleDetailsView = () => setSelectedTraining(trainings[0]); // Set to the first training in the array

  // Function to return to the training catalog
  const handleBackToCatalog = () => setSelectedTraining(null);

  return (
    <div className="min-vh-100">
      <Header />
      {/* Conditional rendering: if selectedTraining is set, show the details view */}
      {selectedTraining ? (
        <div className="container mt-5">
          <button className="btn btn-secondary mb-4" onClick={handleBackToCatalog}>Retour au Catalogue</button>
          <h2>{selectedTraining.title}</h2>
          <table className="details-table">
            <thead>
              <tr>
                <th>Detail</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {selectedTraining.details.map((detail, index) => (
                <tr key={index}>
                  <td>{detail.detail}</td>
                  <td>{detail.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="container mt-5">
          <h1>Formations - Leadership et Stratégie</h1>
          <div className="training-list">
            <div key={trainings[0].id} className="card">
              <button onClick={handleDetailsView} className="btn btn-primary">
                En savoir plus
              </button>
            </div>
          </div>
        </div>
        
      )}
      <Footer />
    </div>
  );
};

export default LeadershipEtStrategieDetails;
